import React from 'react';
import { useLocation } from 'react-router-dom';
import { useDelayedRender } from '~/helpers/hooks';

const NoMatchView = () => {
  const { pathname } = useLocation();
  const delayedRender = useDelayedRender(1000);

  return delayedRender(() => (
    <div className="">
      <div className="row">
        <div className="col">
          <h1 className="header-24">404</h1>
          <p>{`${pathname} not found`}</p>
        </div>
      </div>
    </div>
  ));
};


export default NoMatchView;
